import { MobileUtils } from '~/utils/mobileUtils'

export const isCameraFlow = () => {
  const dorisConfig = localStorage.getItem('@doris:config')
  const storageDorisConfig = dorisConfig ? JSON.parse(dorisConfig) : {}
  return Boolean(MobileUtils.isMobile() || storageDorisConfig?.totem_experience)
}
